import { render, staticRenderFns } from "./MainBanner.vue?vue&type=template&id=20f2a454&scoped=true&"
import script from "./MainBanner.vue?vue&type=script&lang=ts&"
export * from "./MainBanner.vue?vue&type=script&lang=ts&"
import style0 from "./MainBanner.vue?vue&type=style&index=0&id=20f2a454&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f2a454",
  null
  
)

export default component.exports